import Stack from '@mui/material/Stack';
import Table from 'components/table/Table';
import { useGetJamfAssetsTableConfig } from './hooks';
import { TableContainerSx } from './styles';
import { JamfAssetsTableProps } from './types';

const JamfAssetsTable = (props: JamfAssetsTableProps) => {
  const { 'data-testid': dataTestId } = props;
  const config = useGetJamfAssetsTableConfig();

  return (
    <Stack sx={TableContainerSx} data-testid={dataTestId}>
      <Table 
        data-testid={`${dataTestId}-table`}
        {...config} 
      />
    </Stack>
  );
};

export default JamfAssetsTable; 
